module.exports = "/virtual-football/img/fast-choosen-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/fast-choosen-bck.png
// module id = 282
// module chunks = 6